module.exports = __webpack_public_path__ + "img/image-map-keyword-4a507130.png";